(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-slider"]) return;
  try {
    
  $(function(){
    $('.slideshow-media-wrapper > .media-slider-item').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: "<button class='slick-next'><i class='zmdi zmdi-chevron-right'></i></button>",
      prevArrow: "<button class='slick-prev'><i class='zmdi zmdi-chevron-left'></i></button>"
    });
  });

  } catch(e) { console.error(e); }
})();
})();
